module.exports = __webpack_public_path__ + "img/notAllowed.ad70a335.svg";